// BookwiseTable.jsx
import React, { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DownloadButton from "./PDFDownloader";
import { getHeaderClass } from "../../../utils/agGridHelpers";

const BookwiseTable = ({ type, data }) => {
  const gridRef = useRef(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  if (!type || !data) {
    return null;
  }
  let formattedData = [];

  if (type === "bookwise" && !Array.isArray(data)) {
    const { report, grandTotal } = data;

    formattedData = report.map((item) => ({
      bookNo: item.bookNo,
      totalAmount: item.total,
    }));
    formattedData.push({
      rowType: "grandTotal",
      bookNo: "Grand Total",
      totalAmount: grandTotal,
    });
  } else if (type === "bookwisePayMode" && !Array.isArray(data)) {
    const { report, grandTotal } = data;

    report.forEach((item) => {
      item.payModes.forEach((pm) => {
        formattedData.push({
          bookNo: item.bookNo,
          mode: pm.mode,
          amount: pm.totalAmount,
        });
      });

      formattedData.push({
        rowType: "subtotal",
        bookNo: "",
        mode: "Total",
        amount: item.total,
      });
    });

    formattedData.push({
      rowType: "grandTotal",
      bookNo: "",
      mode: "Grand Total",
      amount: grandTotal,
    });
  }


  const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 100,
    headerClass: getHeaderClass,
  };

  const columnDefsBasic = [
    {
      headerName: "S.NO",
      valueGetter: (params) =>
        params.data?.rowType === "grandTotal" ? "" : params.node.rowIndex + 1,
      flex:1,
    },
    {
      field: "bookNo",
      headerName: "Book No",
      valueFormatter: (params) =>
        params.data?.rowType === "grandTotal"
          ? params.value
          : params.value,
          flex:1,
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
      flex:1,
    },
  ];

  const columnDefsPayMode = [
    {
      headerName: "S.NO",
      valueGetter: (params) => {
        const api = params.api;
        let index = 0;
        for (let i = 0; i < params.node.rowIndex; i++) {
          const rowNode = api.getDisplayedRowAtIndex(i);
          if (!rowNode || rowNode.data?.rowType) continue;
          index++;
        }
        return params.data?.rowType ? "" : index + 1;
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    {
      field: "bookNo",
      headerName: "Book No",
      valueFormatter: (params) =>
        params.data?.rowType ? "" : params.value,
      flex:1,
      filter: "agTextColumnFilter"
    },
    {
      field: "mode",
      headerName: "Pay Mode",
      valueFormatter: (params) => params.value || "",
      flex:1,
      filter: "agTextColumnFilter"
    },
    {
      field: "amount",
      headerName: "Total Amount",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
      flex:1,
      filter: "agTextColumnFilter"
    },
  ];

  const getRowStyle = (params) => {
    if (params.data.rowType === "grandTotal") {
      return { fontWeight: "bold", backgroundColor: "#d0ffd0" };
    } else if (params.data.rowType === "subtotal") {
      return { fontWeight: "bold", backgroundColor: "#d0d0ff" };
    }
    return null;
  };

  return (
    <div className="ag-theme-alpine" style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <DownloadButton data={data} type={type} />
      </div>
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        rowData={formattedData}
        columnDefs={type === "bookwise" ? columnDefsBasic : columnDefsPayMode}
        defaultColDef={defaultColDef}
        getRowStyle={getRowStyle}
        domLayout="autoHeight"
        pagination
        paginationPageSize={10}
        paginationPageSizeSelector={[10, 20, 50]}
      />
    </div>
  );
};

export default BookwiseTable;
